module.exports = __webpack_public_path__ + "static/media/Zero.f2071611.png";